import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { DisplayM, HeadingLBold, HeadingSBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import numeral from 'numeral';
import CustomLink from 'components/CustomLink/CustomLink';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/usageStyle';
import { makeStyles } from '@material-ui/core';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { balanceList } from 'views/Numbers/Details/Usage/common/ShowPermission';
import { Balance } from 'utils/api/models/numbers/usage';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IBalanceProps {
	phoneNumberEncoded: string;
	billingType: string;
	accountType: string;
	balance: Balance;
}

const BalanceCard = ({ phoneNumberEncoded, billingType, accountType, balance }: IBalanceProps) => {
	const classes = useStyles();
	const isPrepaid: boolean = billingType.toLowerCase() === 'prepaid';
	const balanceData: string[] = balanceList[accountType.toLowerCase()][billingType.toLowerCase()];

	return (
		<ConditionalRender
			show={balanceData.length !== 0}
			onTrue={() => (
				<Card className={classes.balanceCard} data-test-id="balance">
					<CardBody>
						<GridContainer justify="flex-start">
							<>
								{balanceData.map((type: string, ind: number) => (
									<GridItem xs={12} md={4} key={type} className={classes.balanceElement}>
										<HeadingSBold color={ind === 1 ? 'disabled-light' : 'primary-light'}>
											{translate(`numbers.usage.${type}Value`)}
										</HeadingSBold>
										<div>
											<DisplayM inline color={ind === 1 ? 'disabled-light' : 'primary-light'}>
												<>{balance[type] === 0 ? 0 : numeral(balance[type]).format('0.000')} </>
											</DisplayM>
											<HeadingLBold inline color={ind === 1 ? 'disabled-light' : 'primary-light'}>
												OMR
											</HeadingLBold>
										</div>
									</GridItem>
								))}
								<ConditionalRender
									show={isPrepaid}
									onTrue={() => (
										<GridItem xs={12} md={4} className={classes.topUpButtonContainer}>
											<CustomLink
												color="brand"
												type="bodyMBold"
												to={`/dashboard/payments/topup/${phoneNumberEncoded}`}
											>
												{translate('numbers.usage.topUp')}
											</CustomLink>
										</GridItem>
									)}
								/>
							</>
						</GridContainer>
					</CardBody>
				</Card>
			)}
		/>
	);
};

export default BalanceCard;
